import { Box, Typography } from '@mui/material'
import { type PriorityDisplay } from './PriorityDisplayModel'
import { PRIORITY_CONTENT } from '../../../../../constants/priorityContent'

interface Props {
  question: PriorityDisplay
}

interface PriorityStyleConfig {
  bgColor: string
  primaryColor: string
  borderColor: string
  headerColor: string
}

const PRIORITY_STYLE_CONFIG: Record<number, PriorityStyleConfig> = {
  1: {
    bgColor: 'var(--blue-50)',
    primaryColor: 'var(--blue-500)',
    borderColor: 'var(--blue-300)',
    headerColor: 'var(--blue-700)'
  },
  2: {
    bgColor: 'var(--grey-100)',
    primaryColor: 'var(--purple-500)',
    borderColor: 'var(--purple-500)',
    headerColor: 'var(--blue-500)'
  },
  3: {
    bgColor: 'var(--green-50)',
    primaryColor: 'var(--green-600)',
    borderColor: 'var(--blue-300)',
    headerColor: 'var(--blue-700)'
  },
  4: {
    bgColor: 'var(--light-blue-50)',
    primaryColor: 'var(--light-blue-700)',
    borderColor: 'var(--blue-300)',
    headerColor: 'var(--blue-700)'
  }
}

export const PriorityDisplayContent = ({ question }: Props): JSX.Element => {
  const styleConfig = PRIORITY_STYLE_CONFIG[question.priorityLevel]
  const content = PRIORITY_CONTENT[question.priorityLevel]

  if (styleConfig == null || content == null) {
    return (
      <Box>
        <Typography variant="h6">
          Priority {question.priorityLevel}
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{
      backgroundColor: 'var(--white)',
      border: `1px solid ${styleConfig.primaryColor}`,
      borderRadius: '12px',
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '20px',
      overflow: 'hidden'
    }}
    >
      <Box sx={{
        backgroundColor: styleConfig.primaryColor,
        padding: '20px 40px',
        borderBottom: `1px solid ${styleConfig.primaryColor}`
      }}
      >
        <Typography variant='h4' sx={{ color: 'var(--white)' }}>
          {content.title}
        </Typography>
      </Box>

      <Box sx={{ padding: '20px 40px 40px 40px' }}>
        <Typography variant='h4' color={styleConfig.headerColor} sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>Overall Goals</Typography>
        <Typography variant='body1' sx={{ m: '10px 0', wordBreak: 'break-word', whiteSpace: 'normal' }}>{content.overallGoals}</Typography>
        <ul style={{ margin: '0', paddingInlineStart: '20px' }}>
          {content.listItems.map((item, index) => (
            <li key={index}>
              <Typography variant='body1' sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>{item}</Typography>
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  )
}
